import { format } from "date-fns";

function buildScheduleActionUrl(origin, bookingId, timeValue, action = "", email = "") {
  const target = new URL("/myschedule", origin);
  if (bookingId) {
    target.searchParams.set("bookingId", String(bookingId));
  }
  if (email) {
    target.searchParams.set("email", String(email).trim());
  }
  if (timeValue) {
    try {
      target.searchParams.set("month", format(new Date(timeValue), "yyyy-MM-01"));
    } catch (_err) {
      // ignore invalid date
    }
  }
  if (action) {
    target.searchParams.set("action", action);
  }
  return target.toString();
}

export function getBookingActionLinks({ origin, bookingId, timeValue, email = "" }) {
  return {
    manageBookingUrl: buildScheduleActionUrl(origin, bookingId, timeValue, "", email),
    cancelBookingUrl: buildScheduleActionUrl(origin, bookingId, timeValue, "cancel", email),
    rescheduleBookingUrl: buildScheduleActionUrl(origin, bookingId, timeValue, "reschedule", email),
  };
}

export function getBookingActionTextBlock({ manageBookingUrl, cancelBookingUrl, rescheduleBookingUrl }) {
  return `Manage your booking:
View booking: ${manageBookingUrl}
Cancel booking: ${cancelBookingUrl}
Reschedule booking: ${rescheduleBookingUrl}`;
}

export function getBookingActionHtmlBlock({
  manageBookingUrl,
  cancelBookingUrl,
  rescheduleBookingUrl,
  intro = "Need to make a change? Use one of the options below.",
}) {
  return `
    <div style="margin-top: 16px; padding-top: 12px; border-top: 1px solid #e5e7eb;">
      <p style="font-style: italic; margin-bottom: 12px;">${intro}</p>
      <div style="display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
        <a href="${manageBookingUrl}" target="_blank" rel="noopener noreferrer"
           style="display: inline-block; padding: 10px 16px; text-decoration: none; border-radius: 6px; border: 1px solid #cbd5e1; color: #0f172a;">
          View Booking
        </a>
        <a href="${cancelBookingUrl}" target="_blank" rel="noopener noreferrer"
           style="display: inline-block; padding: 10px 16px; text-decoration: none; border-radius: 6px; border: 1px solid #fecaca; color: #b91c1c;">
          Cancel Booking
        </a>
        <a href="${rescheduleBookingUrl}" target="_blank" rel="noopener noreferrer"
           style="display: inline-block; padding: 10px 16px; text-decoration: none; border-radius: 6px; border: 1px solid #bfdbfe; color: #1d4ed8;">
          Reschedule Booking
        </a>
      </div>
    </div>
  `;
}
